<template>
    <div v-if="logoClient || logSay">
      <img src="@/assets/img/sat.png" v-if="custom == 'SOU'" class="logo-sou" />
      <div v-html="logoClient" v-else-if="logoClient"></div>
      <a href="#" v-else><img :src="logSay"></a>
    </div>
</template>

<script>

export default {
  name: 'LogoHeader',
  props: {
    maxWidth: {
      type: String,
      default: '250px'
    },
    maxHeight: {
      type: String,
      default: '200px'
    },
  },
  computed: {
    logoClient () {
      return this.$store.getters.logoClient;
    },
    logSay () {
      return this.$store.getters.logSay;
    },
    custom() {
      return this.$store.state.custom;
    },
  },
}
</script>
<style scoped>
.logo-sou {
  width: auto;
  height: 200px;
  object-fit: contain;
}
</style>